<script>
  import { Page, BlockTitle, Block, Navbar } from 'framework7-svelte';
  import AppBarLarge from '../nav/AppNavBarLarge.svelte'

</script>

<Page class="page-about">
  <AppBarLarge title="About"/>

  <!-- <BlockTitle medium>Welcome</BlockTitle> -->
  <Block strong>
    <p>
      Dashboards have not been setup for this user or role.
    </p>
  </Block>
</Page>
